import { Badge, BadgeProps } from '@chakra-ui/react'
import { ReactNode } from 'react'

interface AdminBadgeProps extends BadgeProps {
  children: ReactNode
}

export const AdminBadge = ({
  children,
  colorScheme = 'gray',
  variant = 'solid',
  ...props
}: AdminBadgeProps) => (
  <Badge
    colorScheme={colorScheme}
    variant={variant}
    fontSize="9px"
    lineHeight="14px"
    px="6px"
    py="1px"
    borderRadius="4px"
    letterSpacing="0.02em"
    {...props}
  >
    {children}
  </Badge>
)
